import { TableCell, TableCellProps, useTheme } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import React from 'react'
import DisplayFormatedNumber from '../../../components/DisplayFormatedNumber'
import { CompensationCellVariant } from '../types/CompensationCellVariant'

interface OverrideProps {
  compensation?: number
  variant?: CompensationCellVariant
}

type VariantMapping = Partial<Record<CompensationCellVariant, string>> & { default?: string }

interface CompensationCellProps extends Omit<TableCellProps, 'variant'> {
  compensation?: number
  variant?: CompensationCellVariant
}

const getStyleByVariantProp =
  (mapping: VariantMapping) =>
  ({ variant }: OverrideProps) =>
    variant && mapping[variant] ? mapping[variant] : mapping.default

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 46,
      paddingTop: 0,
      paddingBottom: 0,
      textAlign: 'center',
      whiteSpace: 'nowrap',
      color: getStyleByVariantProp({
        default: '#0D689F',
        negative: '#B5223B',
        zero: '#757575',
      }),
    },
    initialVariantStyles: {
      display: 'flex',
      width: '-webkit-fill-available',
      backgroundClip: 'content-box',
      height: '50%',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '4px',
    },
  })
)

const CompensationCell = ({ compensation, variant, onClick, ...other }: CompensationCellProps) => {
  const classes = useStyles({ variant })
  const theme = useTheme()
  const textStyles = theme.typography.lato.body1

  return (
    <TableCell classes={classes} {...other} style={textStyles}>
      {compensation !== undefined ? <DisplayFormatedNumber value={compensation} format="euroInt" /> : null}
    </TableCell>
  )
}

export default CompensationCell
